module.exports = __webpack_public_path__ + "static/media/dashboard.2108835d.svg";